import { CupomEvento } from "../modelos/dtos/CupomEvento";
import { CupomUsuario } from "../modelos/dtos/CupomUsuario";
import { ItemFormModel } from "../modelos/item/ItemFormModel";

export const ITEM_FORM_INITIAL_STATE: ItemFormModel = {
    codigo: "",
    descricao: "",
    usuariosPermitidos: new Array<CupomUsuario>(),
    eventosPermitidos: new Array<CupomEvento>()
  };